import React, { useRef, useEffect, useState, useContext, use } from 'react';

import './Assets.scss';
import UI from './lib.r2/ui/ui-controls';
import { State, Action } from './Provider';
import TextField from '@mui/material/TextField';
import Mark from "mark.js";
// import statusOn from './assets/status_on.svg';
// import statusOff from './assets/status_off.svg';
import store from './Store';

const StatusOn = <svg width="128" height="128" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
<path fill="#ffffff" d="M 104.207,59.701172 V 51.6875 c 0,-3.076985 -2.38194,-5.908203 -5.601531,-5.908203 H 98.597669 68.199 l 2.32e-4,-5.601563 h 30.398437 c 3.219601,0 5.601561,-2.831209 5.601561,-5.908203 V 20.886719 c 0,-3.076984 -2.38196,-5.908203 -5.601561,-5.908203 H 64 29.402344 c -3.219594,0 -5.601563,2.831219 -5.601563,5.908203 v 13.382812 c 0,3.076994 2.381969,5.908203 5.601563,5.908203 H 59.800781 L 59.801,45.779297 H 29.402344 c -3.219594,0 -5.601563,2.831219 -5.601563,5.908203 v 13.382812 c 0,3.077044 2.381999,5.908204 5.601563,5.908204 H 59.801 v 5.599609 H 29.402344 c -3.219564,0 -5.601563,2.833232 -5.601563,5.910156 v 13.38086 c 0,3.077054 2.381999,5.910159 5.601563,5.910159 h 14.392938 l -1.466797,-1.46875 C 41.159313,99.141395 40.397266,97.701614 40.019891,96.177734 H 29.402344 v -14 h 18.359735 l 2.808594,-2.808593 c 3.452788,-3.452843 9.244532,-3.452731 12.697265,0 l 2.808594,2.808593 2.114752,2.113606 0.0077,-2.113606 h 13.24472 l 5.599609,-5.599609 H 68.199 V 70.978516 H 92.642938 L 98.375,65.378919 H 29.402344 V 51.378906 H 98.597656 L 98.601556,65.17 Z M 29.402344,20.578125 H 98.597656 V 34.582031 H 29.402344 Z m 60.796875,2.800781 C 87.879623,23.378906 86,25.258529 86,27.578125 c 0,2.319586 1.879623,4.201172 4.199219,4.201172 2.319584,0 4.201172,-1.881586 4.201172,-4.201172 0,-2.319596 -1.881588,-4.199219 -4.201172,-4.199219 z m 0,30.798828 C 87.879623,54.177734 86,56.059312 86,58.378906 c 0,2.319596 1.879623,4.199219 4.199219,4.199219 2.319584,0 4.201172,-1.879623 4.201172,-4.199219 0,-2.319594 -1.881588,-4.201172 -4.201172,-4.201172 z m 20.498411,7.373047 c -1.01256,0.03514 -2.00275,0.470818 -2.76563,1.210938 L 73.783563,96.910156 59.758173,82.882812 c -1.560409,-1.560388 -4.066545,-1.56042 -5.626953,0 l -8.244141,8.244141 c -1.560358,1.560378 -1.560388,4.066577 0,5.626953 l 25.074219,25.093754 c 1.554658,1.56405 4.071226,1.56198 5.646484,0 L 121.82263,76.630859 c 1.57406,-1.574073 1.58204,-4.085986 0.0215,-5.646484 l -8.24414,-8.244141 c -0.85424,-0.860178 -1.88979,-1.22459 -2.90234,-1.189453 z M 15,107.37891 v 5.59961 h 39.984735 l -5.59375,-5.59961 z m 83.144889,0 -5.599607,5.59961 h 20.462528 v -5.59961 z"></path>
</svg>

const StatusOff = <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
<path fill="#ffffff" d="m 29.402344,15 c -3.21961,0 -5.601563,2.831199 -5.601563,5.908203 v 13.382813 c 0,3.077018 2.381953,5.908203 5.601563,5.908203 h 30.398437 v 5.601562 H 29.402344 c -3.21961,0 -5.601563,2.831199 -5.601563,5.908203 v 13.382813 c 0,3.07706 2.381983,5.908203 5.601563,5.908203 h 25.917968 c 0.373261,-1.46087 1.111322,-2.839112 2.232422,-3.960938 l 1.636719,-1.638671 H 29.402344 v -14 h 69.195312 v 12.853515 l 4.927734,-4.923828 c 0.21546,-0.215598 0.44072,-0.41751 0.67383,-0.605469 v -7.015625 c 0,-3.077004 -2.38195,-5.908203 -5.601564,-5.908203 H 68.199219 v -5.601562 h 30.398437 c 3.219614,0 5.601564,-2.831185 5.601564,-5.908203 V 20.908203 C 104.19922,17.831199 101.81727,15 98.597656,15 H 64 Z m 0,5.599609 H 98.597656 V 34.603516 H 29.402344 Z m 60.796875,2.800782 c -2.3196,0 -4.199219,1.879622 -4.199219,4.199218 0,2.319596 1.879619,4.201172 4.199219,4.201172 2.3196,0 4.201172,-1.881576 4.201172,-4.201172 0,-2.319596 -1.881572,-4.199218 -4.201172,-4.199218 z m 0,30.798828 c -2.3196,0 -4.199219,1.881576 -4.199219,4.201172 0,2.319596 1.879619,4.199218 4.199219,4.199218 2.3196,0 4.201172,-1.879622 4.201172,-4.199218 0,-2.319596 -1.881572,-4.201172 -4.201172,-4.201172 z M 109.71484,61.75 c -0.95825,10e-7 -1.91618,0.368841 -2.65234,1.105469 L 90.599609,79.308594 74.138672,62.835938 c -1.39666,-1.409768 -3.871052,-1.417837 -5.326172,0 l -7.722656,7.728515 c -1.47232,1.47326 -1.47233,3.835331 0,5.308594 l 16.480468,16.492187 -16.5,16.492186 c -1.472329,1.47325 -1.472329,3.85488 0,5.32813 l 7.722657,7.70898 c 1.47232,1.47325 3.853862,1.47325 5.326172,0 l 16.480468,-16.49219 16.482421,16.49219 c 1.47231,1.47325 3.83237,1.47325 5.30469,0 l 7.72461,-7.72851 c 1.47232,-1.47325 1.47233,-3.85482 0,-5.32813 L 103.62891,92.365234 120.0918,75.892578 c 1.47232,-1.47325 1.47232,-3.835328 0,-5.308594 l -7.72461,-7.728515 C 111.63103,62.118838 110.6731,61.749999 109.71484,61.75 Z M 83.759766,65.400391 89.355469,71 h 2.492187 l 5.603516,-5.599609 z M 29.402344,76.599609 c -3.21958,0 -5.601563,2.833237 -5.601563,5.910157 v 13.380859 c 0,3.07706 2.381983,5.910155 5.601563,5.910155 h 30.398437 v 1.26367 l 6.869141,-6.865231 H 29.402344 v -14 h 30.93164 l -2.78125,-2.783203 C 56.729417,78.59217 56.111398,77.63061 55.691406,76.599609 Z M 15,107.40039 V 113 h 40.128906 c -0.313288,-1.89357 -0.02219,-3.87486 0.884766,-5.59961 z"></path>
</svg>



// ---------------------------------------------------------------------------- AppLogo
export const AppLogo = e => {
	return (
		<img id={e.id} className='app-logo' src={e.src} alt='' />
	)
}



// ---------------------------------------------------------------------------- BackgroundImage
export const BackgroundImage = e => {
	return (
		<img className={'background-image' + (e.blur? ' blur' : '')} src={e.src} alt='' />
	)
}



// ---------------------------------------------------------------------------- LayoutImage
export const LayoutImage = e => {
	return (
		<div className='layout-image' id={e.id} style={e.style}>
			<img src={e.src} alt='' />
		</div>
	)
}


// ---------------------------------------------------------------------------- Dropdown
export const Dropdown = props => {
	const [selected, setSelected] = useState(props.selected || '');
	const [open, setOpen] = useState(false);

	const onSelect = e => {
		setSelected(e)
		props.onSelect?.(e)
	}

	const onOpen = () => {
		if (!open) document.addEventListener('click', e => setOpen(false), {once:true})
		setOpen(!open)
	}

	const height = (props.options.length < 8? props.options.length * 30 : 30 * 8) + 8
	const width = Math.ceil(props.options.length / 8) * 120 + 8

	return (
		<div className='dropdown'>
			<div
				className={'dropdown-list' + (open? ' open' : '')}
				style={{
					height : height + 'px',
					width : width + 'px',
				}}
				>
				{props.options.map((e, i) =>
					<div
						className={'dropdown-item' + (selected === e? ' selected' : '')}
						key={i}
						onClick={() => onSelect(e)}
					>{e}</div>
				)}
			</div>
			<div className='dropdown-label' onClick={() => onOpen()}>{selected}</div>
			<i className='material-icons'>{'expand_more'}</i>
		</div>
	)
}


// ---------------------------------------------------------------------------- CheckButton
export const CheckButton = props => {
	const [checked, setChecked] = useState(props.checked);

	const onCheck = e => {
		setChecked(!checked);
		if (props.onClick) props.onClick(!checked);
	}

	useEffect(() => {
		setChecked(props.checked);
	}, [props.checked]);

	return (
		<UI.IconButton
			icon={checked? 'check' : 'close'}
			className={'check-button' + (checked? ' checked' : '')}
			onClick={onCheck}
		/>
	)
}


// ---------------------------------------------------------------------------- LogoutButton
export const LogoutButton = e => {
	const action = useContext(Action);

	return (
		<UI.IconButton
			image={'assets/icons/logout.png'}
			className='button-logout'
			width={60} height={60} padding={20}
			position='tr'
			onClick={e => action('logoff')}
		/>
	)
}


// ---------------------------------------------------------------------------- HomeButton
export const HomeButton = e => {
	const action = useContext(Action);
	
	return (
		<UI.IconButton
			image={'assets/icons/house.png'}
			className='button-home'
			width={60} height={60} padding={20}
			position='tl'
			onClick={e => action('home', true)}
		/>
	)
}


// ---------------------------------------------------------------------------- CloseButton
export const CloseButton = props => {
	return (
		<UI.IconButton
			className='close-button'
			width={props.width || 60}
			height={props.height || 60}
			size={props.size || 20}
			position='tr'
			onClick={props.onClick}
		>╳</UI.IconButton>
	)
}


// ---------------------------------------------------------------------------- StyleButton
export const StyleButton = e => {
	return (
		<UI.IconButton
			id={e.id}
			className={'style-button'
				+ (e.secondary? ' secondary' : '')
				+ (e.disabled? ' disabled' : '')
			}
			icon={e.icon}
			image={e.image}
			label={e.label}
			width={e.width || 160}
			height={e.height || 45}
			margin={e.margin !== undefined? e.margin : 20}
			onClick={e.onClick}
			style={e.style}
		/>
	)
}



// ---------------------------------------------------------------------------- IconButton
export const IconButton = props => {
	return (
		<div className='icon-button'
			id={props.id}
			onClick={props.onClick}
			>
			{props.image && <img src={props.image} alt='' />}
			{props.label && <div>{props.label}</div>}
		</div>
	)
}


// ---------------------------------------------------------------------------- SelectButton
export const SelectButton = props =>
	<div className={'select-button'
		+ (props.className? ' ' + props.className : '')
		+ (props.selected && !props.disabled? ' selected' : '')
		+ (props.disabled? ' disabled' : '')
		+ (props.primary? ' primary' : '')
		}
		onClick={props.onClick}
		>
		{props.label || props.children}
	</div>


// ---------------------------------------------------------------------------- RoundButton
export const RoundButton = e => {
	return (
		<div id={e.id}
			className={'round-button'
				+ (e.className? ' ' + e.className : '')
				+ (e.selected? ' selected' : '')
				+ (e.yellow? ' yellow' : '')
			}
			width={e.width}
			onClick={e.onClick}
			style={{
				width: e.width,
				...e.style
			}}>
			{e.label}
		</div>
	)
}


// ---------------------------------------------------------------------------- GroupButton
export const GroupButton = e => {
	return (
		<div id={e.id}
			className={'group-button'
				+ (e.className? ' ' + e.className : '')
				+ (e.selected? ' selected' : '')
			}
			width={e.width}
			onClick={e.onClick}
			style={{
				width: e.width,
				...e.style
			}}>
			{e.label}
		</div>
	)
}


// ---------------------------------------------------------------------------- ButtonGroup
export const ButtonGroup = props => {
	const [selected, setSelected] = useState(props.selectedIndex);

	const onSelect = e => {
		setSelected(e);
		if (props.onSelect) props.onSelect(e);
	}

	return (
		<div className={'button-group' + (props.className? ' ' + props.className : '')}>
			{props.source.map((e, i) => 
				// <StyleButton key={i}
				<GroupButton key={i}
					selected={i === selected}
					onClick={() => onSelect(i)}
					label={e}
				/>
			)}
		</div>
	)
}


const getDiff = (a, b) => {
	if (!b || !a) return null;
	a = Number(a);
	b = Number(b);
	return a < b? a / b : b / a;
	// let v = a / b;
	// return v < 1? (1/v-1) * 100 : (v-1) * 100;
}


// ---------------------------------------------------------------------------- SearchResultList
export const SearchView = props => {
	const state = useContext(State);
	const data = useRef();
	const [filter, setFilter] = useState([]);
	const [value, setValue] = useState('')
	const selected = useRef();
	const delay = useRef();


	useEffect(() => {
		let b0 = state.bundle;
		let t0 = Number(b0.attributes.weight);
		let l0 = Number(b0.attributes.length);
		let h0 = Number(b0.attributes.height);
		let w0 = Number(b0.attributes.width);

		let g = state.bundle.gtin;
		// let g6 = g.substring(0, 6);
		let n, d, t, l, h, w;

		data.current = state.warehouse._bundles.filter(b => {
			if (b.id === b0.id) return false;				//same as current
			if (b.status !== 'complete') return false;		//status not complete
			if (!b.gtin) return false;						//no gtin

			n = 0;
			d = 0;

			t = getDiff(b.attributes.weight, t0);		//get difference of weight | 1 = fit
			if (t !== null){
				n ++;
				d += t;
			}

			l = getDiff(b.attributes.length, l0);		//difference factor 0 - 1
			if (l !== null){
				n ++;
				d += l;
			}
			h = getDiff(b.attributes.height, h0);
			if (h !== null){
				n ++;
				d += h;
			}
			w = getDiff(b.attributes.width, w0);
			if (w !== null){
				n ++;
				d += w;
			}

			b._diff = n? d / n * 100 : 0;				//difference in percent
			b._diff_str = b._diff.toFixed(2) + ' %';

			return true;
		});

		let found = data.current.sort((a, b) => b._diff - a._diff).filter((e, i) => i < 100);

		setFilter(found);
	}, [])


	const onSearch = e => {
		if (selected.current) onSelect(null);	//clear current selection

		let v = e.toLowerCase();
		setValue(v);

		clearTimeout(delay.current)

		delay.current = setTimeout(e => {
			let arr = v.split(' ');
			let found = data.current;		//get whole dataSet
	
			arr.forEach(a => {
				found = found.filter((b, i) => b._search.indexOf(a) > -1)
			})
	
			found = found.sort((a, b) => a._comp - b._comp);
			found = found.filter((e, i) => i < 100);	//get only max 100 items
	
			setFilter(found);

		}, 200)
	}


	const onSelect = e => {
		selected.current = e;
		if (props.onSelect) props.onSelect(e);
	}


	return (
		<div className='search-view'>
			<div className='search-input filter'>
				<TextField
					label={global.getLabel('search-input')}
					style={{fontSize:24, width:'100%'}}
					inputProps={{
						style: {
							paddingTop: 10,
							paddingBottom: 10
						}
					}}
					onChange={e => onSearch(e.target.value)}
					value={value}
					inputRef={input => input && input.focus()}
				/>

				<UI.IconButton
					className={'search-button' + (!filter.length? ' disabled' : '')}
					image='assets/icons/magnifier.png'
				/>

				{value && <CloseButton onClick={() => onSearch('')} size={20} width={50} height={50} />}

				<div className='search-info'>{
					(filter.length === 0?
						global.getLabel('found-not-similar', 'Kein Produkt gefunden') + '!' :
						global.getLabel('found-some-similar', 'Produkte gefunden') + ': '
							+ filter.length + ' / '
							+ data.current.length
						)
				}</div>
			</div>

			<SearchResultList mark={value} source={filter} onSelect={onSelect} ext />
		</div>
	)
}



// ---------------------------------------------------------------------------- SearchResultList
export const SearchResultList = props => {
	const [select, setSelect] = useState();

	const onSelect = e => {
		setSelect(s => e === s? null : e);
		if (props.onSelect) e === select? props.onSelect(null) : props.onSelect(e);
	}

	useEffect(() => {
		let mark = new Mark(document.querySelector('.search-result-list'));
		mark.unmark({
			done: () => mark.mark(props.mark)
		});
	}, [props.source, props.mark])


	return (
		<div className='search-result-list'>
			{props.source.map((e, i) =>
				<div key={i}
					className={'search-result-item' + (e === select? ' selected' : '')}
					onClick={() => onSelect(e)}
					>
					<div className='search-result-box'>
						<div className='search-result-label'>
							<div className='search-result-name'>
								{e.name}
							</div>
							{e.articleNo && <div className='search-result-article'>
								{e.articleNo}
							</div>}
						</div>

						<div className='search-result-gtins'>
							{e.gtins?.map((g, i) => <span key={i}>{g}</span>)}
						</div>


						{props.ext &&
							<div className='search-result-value'>
								<div className='sr-value'><span style={{width:(e._diff < 100? e._diff : 100) + '%'}} /></div>
								<div className='sr-label'>{e._diff_str}</div>
							</div>
						}
					</div>

					{e.attributes.image_iso &&
						<img className='search-result-image'
							src={e.attributes.image_iso.replace('/api/upload', '/upload')} alt=''
						/>
					}

					{(!props.ext && e.status === 'complete') &&
						<div className='search-result-dot' />
					}
				</div>
			)}
		</div>
	)
}


// ---------------------------------------------------------------------------- NetworkStatus
export const NetworkStatus = props => {
	const isOnline = store.use('isOnline')

	return (
		<div className='net-state' onClick={props.onClick}>
			{isOnline? StatusOn : StatusOff}
		</div>
	)

	// return (
	// 	<img
	// 		className='net-state'
	// 		src={isOnline? statusOn : statusOff}
	// 		alt=''
	// 		onClick={props.onClick}
	// 	/>
	// )
}


// ---------------------------------------------------------------------------- InfoView
export const InfoView = props => {
	const info = store.info

	const parseValue = item => {
		if (typeof item === 'string') return item
		if (!item || typeof item !== 'object' || !item.value) return '---'
		if (typeof item.value === 'string' || typeof item.value === 'number') return item.value
		return '---'
	}

	return (
		<div className='info-view'>
			{Object.entries(info).map((e, i) => <div key={i} className='info-row'>
				<div className='info-label'>{e[1]?.label || e[0]}</div>
				<div className='info-value'>{parseValue(e[1])}</div>
			</div>)}
		</div>
	)
}
